export var makeUrlDomainIndependent = function (input) {
    if (!input) {
        return input;
    }
    return input.replace(/http(s?):\/\//gi, '//');
};
